<template>
  <b-card
    no-body
    class="shadow-body"
  >
    <b-card-body>
      <p>{{ inputValues[1] ? inputValues[1].value : '' }}</p>
      <p class="link-tag">
        {{ inputValues[2] ? inputValues[2].value : '' }}
      </p>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="mt-2"
      >
        <feather-icon
          icon="Link2Icon"
          class="mr-50"
          size="16"
        />
        <span class="align-middle">Visit URL</span>
      </b-button>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BCardBody,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    inputValues: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
